import { Component, OnInit } from "@angular/core";
import {
  AlertController,
  LoadingController,
  Platform,
  ToastController,
} from "@ionic/angular";
import { Router } from "@angular/router";
import { Storage } from "@ionic/storage";
import { Helper } from "../services/Helper";
import { APIService } from "../services/APIService";
import { Network } from "@ionic-native/network/ngx";
import { AppData } from "../models/AppData";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

declare var RazorpayCheckout: any;

import * as moment from "moment";
import { WindowRefService } from "../services/window-ref.service";

@Component({
  selector: "app-all-slots",
  templateUrl: "./all-slots.page.html",
  styleUrls: ["./all-slots.page.scss"],
})
export class AllSlotsPage implements OnInit {
  docfee: any;
  _teamId: any;
  docEmail: any;
  loader: any;
  orderID: any;
  morningSlots: any;
  eveningSlots: any;
  AppData: AppData;
  self: any;
  appDate: any;
  todayDate: Date = new Date();
  selDate: any;
  finalDate: any;
  mnglot: boolean;
  evglot: boolean;
  patid: any;
  patinetAppData: any;
  finalTIme: any;
  selectedIndex: any;
  selectedTIme: any;
  newSlots: any;
  docfirstname: any;
  docphone: any;
  razor_acc: any;
  razorPaymentId: any;
  imageData: any;
  appoinmentId: any;
  fileName: any;
  email: any;
  phone: any;
  firstname: any;
  lastname: any;
  fileType: any;
  resheduleAppointId: any;
  resheduleDocId: any;
  resheduleDocFname: any;
  resheduleDocLname: any;
  resheduleDocPhone: any;

  weekDays = {
    0: "SUN",
    1: "MON",
    2: "TUE",
    3: "WED",
    4: "THU",
    5: "FRI",
    6: "SAT",
  };

  constructor(
    private Router: Router,
    private storage: Storage,
    private router: Router,
    public toastController: ToastController,
    private network: Network,
    public loadingController: LoadingController,
    public helper: Helper,
    private apiservice: APIService,
    private alertCtrl: AlertController,
    private platform: Platform,
    private http: HttpClient,
    private winRef: WindowRefService
  ) {
    this.mnglot = false;
    this.evglot = false;
    this.AppData = new AppData();
    this.selDate = new Date();
  }

  ionViewWillEnter() {
    this.platform.backButton.subscribeWithPriority(1, () => {
      this.dismissLoading();
      this.router.navigate(["appointment-form"]);
    });

    let urlParam = this.router.url.split("/");
    this.resheduleAppointId = urlParam[2];
    this.resheduleDocId = urlParam[3];

    this.resheduleDocFname = urlParam[4];
    this.resheduleDocLname = urlParam[5];
    this.resheduleDocPhone = urlParam[6];

    console.log("resheduleAppointId", this.resheduleAppointId);
    console.log("resheduleDocId", this.resheduleDocId);

    if (!this.resheduleAppointId) {
      this.storage.get("patinetAppData").then((patinetAppData) => {
        this.patinetAppData = patinetAppData;
        this.imageData = patinetAppData.imageData;
        let seperation = this.imageData.split(",");
        this.imageData = seperation[1];
        console.log("imageData", this.imageData);

        this.fileType = patinetAppData.fileType;
        this.fileName = patinetAppData.fileName;
      });
      console.log("patinetAppData", this.patinetAppData);

      this.storage.get("_teamId").then((_teamId) => {
        this.storage.get("docfee").then((docfee) => {
          this.storage.get("docEmail").then((docEmail) => {
            this.storage.get("self").then((self) => {
              this.storage.get("docfirstname").then((docfirstname) => {
                this.storage.get("docphone").then((docphone) => {
                  this.storage.get("tokenData").then((patid) => {
                    this.storage.get("email").then((email) => {
                      this.storage.get("phone").then((phone) => {
                        this.storage.get("firstname").then((firstname) => {
                          this.storage.get("lastname").then((lastname) => {
                            this.docfee = docfee;
                            this.docEmail = docEmail;
                            this.self = self;
                            this.docfirstname = docfirstname;
                            this.docphone = docphone;
                            this.patid = patid;
                            this._teamId = _teamId;
                            // this._teamId = ;
                            this.email = email;
                            this.phone = phone;
                            this.firstname = firstname;
                            this.lastname = lastname;

                            console.log("out", patid);
                            console.log("_teamId", _teamId);
                            console.log("firstname", this.firstname);
                            console.log("firstname", this.docfee);
                          
                            this.storage.get("docNewId").then((docNewId) => {
                              this._teamId = docNewId;
                              var str = this.todayDate.getDay();
                              this.finalDate = this.weekDays[str];
                              this.getSlots(this.finalDate, this.todayDate);
                              console.log('DocNewID', this._teamId);
                            });
                          });
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    } else {
      if (this.resheduleDocId) {
        this.storage.get("firstname").then((firstname) => {
          this.storage.get("lastname").then((lastname) => {
            this.firstname = firstname;
            this.lastname = lastname;
            console.log("firstname", this.firstname);

            this._teamId = this.resheduleDocId;
            var str = this.todayDate.getDay();
            this.finalDate = this.weekDays[str];
            console.log("this.finalDate", this.finalDate);
            this.getSlots(this.finalDate, this.todayDate);
          });
        });
      }
    }
  }

  reshedule() {
    this.presentLoading().then(() => {
      var time = moment(this.finalTIme, ["h:mm A"]).format("HH:mm");
      var date = moment(this.selDate).format("MM-DD-YYYY");
      var datetime = new Date(date + " " + time);
      var appointmentSchedule = datetime.toISOString();
      let SlotBookDate = moment(appointmentSchedule, moment.ISO_8601).format(
        "DD-MM-YYYY"
      );

      console.log("SlotBookDate", SlotBookDate);
      console.log("appointmentSchedule", appointmentSchedule);
      console.log("SlotBookDate", SlotBookDate);
      console.log("finalTIme", this.finalTIme);
      console.log("appointId", this.resheduleAppointId);

      console.log("resheduleDocFname", this.resheduleDocFname);
      console.log("resheduleDocLname", this.resheduleDocLname);
      console.log("resheduleDocPhone", this.resheduleDocPhone);

      this.apiservice
        .resheduleAppointment({
          appointId: this.resheduleAppointId,
          appointmentSchedule: appointmentSchedule,
          SlotBookDate: SlotBookDate,
          finalTIme: this.finalTIme,
          docFirstname: this.resheduleDocFname,
          docLastname: this.resheduleDocLname,
          docphone: this.resheduleDocPhone,
          patfname: this.firstname,
          patlname: this.lastname,
        })
        .subscribe(
          (response) => {
            if (response.body.status == true) {
              this.dismissLoading();
              this.router.navigate(["/tabs/tab2"]);
              this.helper.presentToastSuccess(
                "Appointment rescheduled successfully"
              );
            } else {
              this.dismissLoading();
              this.helper.presentToastError(response.body.msg);
            }
          },
          (error) => {
            this.dismissLoading();
            this.helper.presentToastError("Pleae try again later!");
          }
        );
    });
  }

  createOrder() {
    if (!(this.network.type !== "none" && this.network.type !== "unknown")) {
      this.helper.presentToastError("Please on Internet Connection!");
    } else {
      this.presentLoading().then(() => {
        this.apiservice
          .createOrderID({ amount: Number(this.docfee) * 100 })
          .subscribe(
            (response) => {
              this.orderID = response.body.id;
              console.log(this.orderID);
              this.dismissLoading();
              if (this.orderID) {
                var str = this.todayDate.getDay();
                this.finalDate = this.weekDays[str];
                console.log("this.finalDate", this.finalDate);
                this.payWithRazor()
                
              }
            },
            (error) => {
              this.dismissLoading();
              this.helper.presentToastError("Pleae try again later!");
            }
          );
      });
    }
  }

  getSlots(selDate, todayDate) {
    var date = moment(todayDate).format("DD-MM-YYYY");
    console.log(date);
    console.log(selDate);
    if (!(this.network.type !== "none" && this.network.type !== "unknown")) {
      this.helper.presentToastError("Please on Internet Connection!");
    } else {
      this.presentLoading().then(() => {
        this.apiservice
          .getSlots({
            _teamId: this._teamId,
            day: selDate,
            date: date,
          })
          .subscribe(
            (response) => {
              console.log(response.body.result);
              const allData = response.body.result;
              if (response.body.status == "fail") {
                this.morningSlots = null;
                this.eveningSlots = null;
                this.dismissLoading();
                this.helper.presentToastError("slots not available");
              } else if (response.body.status == "success") {
                allData.forEach((element) => {
                  console.log(element);
                  if (element.morning_slot) {
                    const mslots = element.morning_slot;
                    this.morningSlots = mslots.split(",");

                    let todayDate = new Date();

                    if (this.selDate.getDate() === todayDate.getDate()) {
                      let timeNow = this.formatAMPM(todayDate);

                      this.morningSlots.map((item, index) => {
                        // console.log(
                        //   "item",
                        //   moment(item, ["h:mmA"]).format("HH:mm")
                        // );
                        // console.log(
                        //   "timeNow",
                        //   moment(timeNow, ["h:mmA"]).format("HH:mm")
                        // );

                        if (
                          moment(timeNow, ["h:mmA"]).format("HH:mm") >
                          moment(item, ["h:mmA"]).format("HH:mm")
                        ) {
                          console.log("success");
                          this.morningSlots[index] = "#" + item;
                        }
                      });
                    }
                  }
                  if (element.evening_slot) {
                    const eslots = element.evening_slot;
                    this.eveningSlots = eslots.split(",");
                    let todayDate = new Date();

                    if (this.selDate.getDate() === todayDate.getDate()) {
                      let timeNow = this.formatAMPM(todayDate);

                      this.eveningSlots.map((item, index) => {
                        console.log(
                          "item",
                          moment(item, ["h:mmA"]).format("HH:mm")
                        );
                        console.log(
                          "timeNow",
                          moment(timeNow, ["h:mmA"]).format("HH:mm")
                        );

                        if (
                          moment(timeNow, ["h:mmA"]).format("HH:mm") >
                          moment(item, ["h:mmA"]).format("HH:mm")
                        ) {
                          console.log("success");
                          this.eveningSlots[index] = "#" + item;
                        }
                      });
                    }
                    console.log("eveningSlots", this.eveningSlots);
                  }
                });
                this.get_razorAcc();
              }
              this.dismissLoading();
            },
            (error) => {
              this.dismissLoading();
              this.helper.presentToastError("Pleae try again later!");
            }
          );
      });
    }
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }

  async presentLoading() {
    this.loader = await this.loadingController.create({
      translucent: true,
      backdropDismiss: true,
    });
    await this.loader.present();
  }

  async dismissLoading() {
    await this.loader.dismiss();
  }

  ngOnInit() {}

  DateChange(event) {
    console.log(event);
    this.eveningSlots = [];
    this.morningSlots = [];

    var str = this.selDate.getDay();
    this.finalDate = this.weekDays[str];
    console.log(this.finalDate);
    this.getSlots(this.finalDate, event.value);
  }

  selectSlot(val: any, item: any, i) {
    console.log("i", i);
    if (val == 1) {
      this.evglot = null;
      this.mnglot = item;
      this.finalTIme = this.mnglot;
      this.selectedIndex = i;
      this.selectedTIme = "AM";
      console.log(this.selectedTIme, this.selectedIndex);
    }

    if (val == 0) {
      this.mnglot = null;
      this.evglot = item;
      this.finalTIme = this.evglot;
      this.selectedIndex = i;
      this.selectedTIme = "PM";
      console.log(this.selectedTIme, this.selectedIndex);
    }

    console.log("finalTIme", this.finalTIme);
  }

  get_razorAcc() {
    console.log("inside get_razorAcc");

    this.presentLoading().then(() => {
      this.apiservice.get_razorAcc({ _teamId: this._teamId }).subscribe(
        (response) => {
          if (response) {
            try {
              this.razor_acc = response.body.result[0].razor_acc;
            } catch (e) {
              this.helper.presentToastError("Doctor Email Id does not Exist");
            }
            console.log("get_razorAcc", this.razor_acc);
            this.dismissLoading();
          }
        },
        (error) => {
          console.log("error get_razorAcc");
          this.dismissLoading();
          // this.helper.presentToastError("Something went wrong");
        }
      );
    });
  }

  payWithRazor() {
    
    // console.log("amount", this.docfee);
    // console.log("orderID", this.orderID);


     if (!this.finalTIme) {
      this.helper.presentToastError("Please select Time Slot");
    } else if (!this.selDate) {
      this.helper.presentToastError("Please select Date Slot");
    } else if (!this.razor_acc) {
      this.helper.presentToastError("Doctor Razor account not available");
    } else {
          console.log("inside razopay");
        const amount = Number(this.docfee) * 100;
      const options: any = {
        key: 'rzp_test_jd8FsxgutGPrfH', 
        password: "6CUgESnJ72ZayVdzSj35nND1",
        description: 'Make Payment for Appointment',  // product description
        image: 'http://vytal.qovid19.com/assets/payment_logo.png', // company logo or product image
        currency: "INR",
        order_id: this.orderID, // order_id created by you in backend
        amount,
        modal: {
          // We should prevent closing of the form when esc key is pressed.
          escape: false,
        },
        notes: {
          // include notes if any
        },
        theme: {
          color: '#0c238a'
        }
      };
      options.handler = ((response, error) => {
        options.response = response;
        this.razorPaymentId = response.razorpay_payment_id
        console.log(this.razorPaymentId);
        console.log(options);
        this.bookAppointment(); // call your backend api to verify payment signature & capture transaction
      });
      options.modal.ondismiss = (() => {
        // handle the case when user closes the form while transaction is in progress
        this.helper.presentToastError("Payment Not done Yet!");
      });
      const rzp = new this.winRef.nativeWindow.Razorpay(options);
      rzp.open();
    }
    // if (!this.finalTIme) {
    //   this.helper.presentToastError("Please select Time Slot");
    // } else if (!this.selDate) {
    //   this.helper.presentToastError("Please select Date Slot");
    // } else if (!this.razor_acc) {
    //   this.helper.presentToastError("Doctor Razor account not available");
    // } else {
    //   console.log("inside razopay");
    //   const amount = Number(this.docfee) * 100;
    //   // return false;
    //   const options = {
    //     description: "Make Payment for Appointment",
    //     image: "http://vytal.qovid19.com/assets/payment_logo.png",
    //     currency: "INR", // your 3 letter currency code

    //     // key: "rzp_live_LlJeAy3EhYMCmY",
    //     // password: "JrR1GAWX0vEpQpQVoyVeGLvL",

    //     key: "rzp_test_jd8FsxgutGPrfH", // DEV
    //     password: "6CUgESnJ72ZayVdzSj35nND1", //DEV
      
    //     order_id: this.orderID,

    //     amount, // Payment amount in smallest denomiation e.g. cents for USD
    //     name: "",
    //     prefill: {
    //       email: "",
    //       contact: "",
    //       name: "",
    //     },
    //     theme: {
    //       color: "#0d5191",
    //     },
    //     modal: {
    //       ondismiss() {
    //         this.loader.dismiss();
    //         // alert('dismissed');
    //       },
    //     },
    //   };

    //   const successCallback = (success) => {
    //     alert("razorPaymentId " + success);
    //     this.razorPaymentId = success;
    //     console.log("success", success);
    //     this.bookAppointment();
    //   };

    //   const cancelCallback = function (error) {
    //     this.helper.presentToastError("Payment Not done Yet!");
    //   };

    //   RazorpayCheckout.open(options, successCallback, cancelCallback);
    // }
  }

  xd() {
    this.razorPaymentId = "success";

    console.log(this.self);
    if (this.self == 1) {
      this.addAppointment();
    } else {
      this.addpatient();
    }
  }

  bookAppointment() {
    this.presentLoading().then(() => {
      let postData = new FormData();

      if (this.imageData && this.fileType) {
        console.log("fileType", this.fileType);
        var imageBlob;

        if (this.fileType == 1) {
          const date1 = new Date().valueOf();
          const imageName = date1 + ".jpeg";
          const imageBlob = this.dataURItoBlob(this.imageData);
          console.log("imageblob", imageBlob);
          postData.append("appointmentFiles", imageBlob, imageName);
        }
        if (this.fileType == 2 && this.fileName) {
          imageBlob = this.createBlob(this.imageData);
          postData.append("appointmentFiles", imageBlob, this.fileName);
        }
      }

      // UserData

      var a = moment();
      var b = moment(this.patinetAppData.age).format("YYYY-MM-DD");
      var age = moment.duration(a.diff(b));
      var years = age.years();
      var months = age.months();

      postData.append("firstname", this.patinetAppData.firstname);
      postData.append("lastname", this.patinetAppData.lastname);
      postData.append("dob", this.patinetAppData.dob);
      postData.append("age", years + " years " + months + " months ");
      postData.append("gender", this.patinetAppData.gender);
      postData.append("phone", this.patinetAppData.phone);
      postData.append("email", this.patinetAppData.email);
      postData.append("_teamId", this._teamId);

      // AppointData

      var time = moment(this.finalTIme, ["h:mm A"]).format("HH:mm");
      var date = moment(this.selDate).format("MM-DD-YYYY");
      var datetime = new Date(date + " " + time);
      var datetimeISo = datetime.toISOString();

      postData.append("appointmentSchedule", datetimeISo);
      postData.append("notes", this.patinetAppData.notes);
      postData.append("service", "Followup");
      postData.append("type", "appointment");
      postData.append("finalTIme", this.finalTIme);
      postData.append(
        "SlotBookDate",
        moment(datetimeISo, moment.ISO_8601).format("DD-MM-YYYY")
      );

      // Razor Data
      postData.append("razorpay_payment_id", this.razorPaymentId);
      postData.append("razorpay_order_id", this.orderID);

      console.log("postData", postData);

      this.apiservice.bookAppointment(postData).subscribe(
        (response) => {
          this.dismissLoading();
          if (response.body.status == true) {
            this.helper.presentToastSuccess("Appointment Booked Successfully");
            localStorage.setItem('patient_first_name',this.patinetAppData.firstname);
            localStorage.setItem('patient_last_name',this.patinetAppData.lastname);
            localStorage.setItem('patient_email',this.patinetAppData.email);
            this.router.navigate(["/tabs/tab1"]);
          } else {
            this.helper.presentToastSuccess("Something went wrong");
          }
        },
        (error) => {
          this.dismissLoading();
          console.log(error);
        }
      );
    });
  }

  addpatient() {
    console.log("inside addpatient");

    this.apiservice.addpatient(this.patinetAppData).subscribe(
      (response) => {
        if (response) {
          this.patid = response.body.result._id;
          console.log("patient added", this.patid);
          alert("patient added");
          this.addAppointment();
        }
      },
      (error) => {
        console.log("patient not added");
        alert("patient not added");
        this.helper.presentToastError("Something went wrong");
      }
    );
  }

  addAppointment() {
    if (!this.finalTIme) {
      this.helper.presentToastError("Please select Time Slot");
    } else if (!this.selDate) {
      this.helper.presentToastError("Please select Date Slot");
    } else {
      this.presentLoading().then(() => {
        if (this.selectedTIme == "AM") {
          const tempslots = this.morningSlots;
          tempslots[this.selectedIndex] = "*" + tempslots[this.selectedIndex];
          this.newSlots = tempslots.toString();
          console.log(this.newSlots, typeof this.newSlots);
        }

        if (this.selectedTIme == "PM") {
          const tempslots = this.eveningSlots;
          tempslots[this.selectedIndex] = "*" + tempslots[this.selectedIndex];
          this.newSlots = tempslots.toString();
          console.log(this.newSlots);
        }

        console.log("finalTIme", this.finalTIme);
        console.log("selDate", this.selDate);

        var selDateNew = new Date(this.selDate).toISOString();
        console.log("selDateNew", selDateNew);

        var time = moment(this.finalTIme, ["h:mm A"]).format("HH:mm");
        console.log("time", time);

        var date = moment(this.selDate).format("MM-DD-YYYY");
        console.log("date", date);

        var datetime = new Date(date + " " + time);
        console.log("datetime", datetime);

        var datetimeISo = datetime.toISOString();
        console.log("datetimeISo", datetimeISo);

        // var datetimeISo = datetime.toISOString();
        // console.log("datetimeISo", datetimeISo);

        this.AppData._patientId = this.patid;
        this.AppData._teamId = this._teamId;
        this.AppData.appointmentSchedule = datetime;
        this.AppData.notes = this.patinetAppData.description;
        this.AppData.sentpaymentLink = "false";
        this.AppData.service = "Followup";
        this.AppData.type = "appointment";

        console.log("inside addAppointment", this.AppData);

        let url = "https://connectdev.vytal.in:3003/api/add_Appoinment";
        const date1 = new Date().valueOf();

        let postData = new FormData();

        if (this.imageData) {
          const imageName = date1 + ".jpeg";
          const imageBlob = this.dataURItoBlob(this.imageData);
          console.log("imageblob", imageBlob);
          postData.append("appointmentFiles", imageBlob, imageName);
        }

        postData.append("_patientId", this.patid);
        postData.append("_teamId", this._teamId);
        postData.append("appointmentSchedule", datetimeISo);
        postData.append("notes", this.patinetAppData.description);
        postData.append("sentpaymentLink", "false");
        postData.append("service", "Followup");
        postData.append("type", "appointment");
        postData.append("finalTIme", this.finalTIme);

        console.log("postData", postData);

        this.apiservice.add_Appoinment(postData).subscribe(
          (response) => {
            console.log(response);
            alert("appoint added");

            this.appoinmentId = response.body.appointId;
            console.log("appoinmentId", this.appoinmentId);
            this.transferOnResp();
          },
          (error) => {
            alert("appoint not added");

            this.dismissLoading();
            this.helper.presentToastError("Something went wrong");
          }
        );

        let data: Observable<any> = this.http.post(url, postData);
        data.subscribe((result) => {
          console.log("appointment result");
          this.transferOnResp();
        });
        this.dismissLoading();
      });
    }
  }

  // upload(){

  // this.imageData ="/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCAAeABYDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAgJBgME/8QAJxAAAgIBBAIBBAMBAAAAAAAAAgMBBAUGERITAAcUCAkhIiMkMjP/xAAXAQADAQAAAAAAAAAAAAAAAAABAgQD/8QAKREBAAEDAgQEBwAAAAAAAAAAARECITEDQQASEyIEUWFxMlJygaGx4f/aAAwDAQACEQMRAD8AUX6MvWuO1VlcAp6IBVllWtb5iLQs2DHqK3u6T3YmvSmupkMWliXyroURK41v+4L9vvU2ifTuhdV4deBPG5WirOW7jKcXYp4y6GLKo/sTXNaGNUyy5s/OpVLh2lTBxaroemIv0ze762l8hSsqujC0JXagJAYmSUBTJAJxtJT1SLxGBWMdk7fmJ8oJ72+uXNa80nhMHn85kMniquNnD1f7pRVpiVqsqlSKmO/IXPtyoGRHVXJSxOIBkEs6PiatKitSnqUiULSI2DaIgws3zYjimvTNVpVWlq7+6HtiI90uCTheIn+9dGYLH5YcXSrJr0KtphhXrssL6nMKyBbzWiSiXQkrDJZBNsMbJva0lqYR55vaGq8ff1A5qY/4lKJiIEgMB36SiZ3KeADP5/zyae0zvHh5ia+uw1aZU2VWJnlccrvZZZWc8F0tOpnmjG8fL5WdyTad8rrpbW+VUQSDjhSSlRMkRWUiQvZ+eAzHW5bZgZ3iChkwQ/ovlvb3snKvpfGCy05OvUYZxO0LMVrg3wuTCJX2v4sCD5mUlMrKFxHi6u1xpbRXxyyWMyjm2XWjF1BdZ0kdaubT7E3LyUgInYg0yoeX8YAUwIDPnGz7n0IB11Mw+pe1llPUS6mn+shYkzVXctjzkUfIhBFKSFywFmzXCcJiiqjlU6ZUXfiCLH7jhBLTVfDZhxbF7p5EmY40ue1fMNW2N92chiTYRFCwKTDflHKYmXFATJTP6FMxAkvw8SbWns7P5LUuQt4G9bxWNUXxqNEukATW5lvJoSBol5tURy3czEJhUMIIiBPG6Za8YtmMenv98WiUdRmzb6KX8t/X+5//2Q=="

  //   this.presentLoading().then(() => {

  //   console.log("inside upload")

  //   let  url = 'https://vytal.qovid19.com:3003/api/SendImgPres';
  //   const date = new Date().valueOf();

  //   const imageName = date+ '.jpeg';
  //   const imageBlob = this.dataURItoBlob(this.imageData);
  //   console.log("imageblob",imageBlob)
  //   let  postData = new FormData();
  //   postData.append('file', imageBlob,imageName);
  //   postData.append('doctorname', this.doc_name);
  //   postData.append('phone', this.pat_phone);

  //   console.log("postData",postData)

  //   let data:Observable<any> = this.http.post(url,postData);
  //   data.subscribe((result) => {
  //     console.log(result);
  //     this.dismissLoading();
  //     this.router.navigate(['tabs/tab1'])
  //     this.helper.presentToastSuccess("Prescription link sent successfully to the patient");
  //   });
  //   this.dismissLoading();

  //   });

  // }

  transferOnResp() {
    if (this.selectedTIme == "AM") {
      var type = "morning";
    }
    if (this.selectedTIme == "PM") {
      var type = "evening";
    }

    var SlotBookDate = moment(
      this.AppData.appointmentSchedule,
      moment.ISO_8601
    ).format("DD-MM-YYYY");

    this.apiservice
      .transferOnResp({
        razorpay_payment_id: this.razorPaymentId,
        razorpay_order_id: this.orderID,
        appoinmentId: this.appoinmentId,
        account: this.razor_acc,
        slot: this.newSlots,
        videoLink: "",
        paymentMode: "Online",
        SlotBookDate: SlotBookDate,
        type: type,
        day: this.finalDate,
        _teamId: this._teamId,
        amount: this.docfee,
      })
      .subscribe(
        (response) => {
          if (response) {
            console.log("transferOnResp succcess", response);
            alert("transferOnResp succcess");

            // this.router.navigate(['/tabs/tab1']);
            // this.helper.presentToast("Appointment sheduled for selected date and time ");
            this.sendMessage();
            // this.dismissLoading();
          }
        },
        (error) => {
          alert("transferOnResp fail");

          // this.router.navigate(['/tabs/tab1']);
          // this.helper.presentToast("Appointment sheduled for selected date and time ");
          this.sendMessage();
          // this.helper.presentToastError('Something went wrong');
        }
      );
  }

  sendMessage() {
    let formatted = moment(
      this.AppData.appointmentSchedule,
      moment.ISO_8601
    ).format("DD MMM YYYY LT");

    this.apiservice
      .sendMessage({
        phone: this.phone,
        doctorname: this.firstname + " " + this.lastname,
        "  messagecontent": "null",
        appointDate: formatted,
        email: this.email,
      })
      .subscribe(
        (response) => {
          if (response) {
            console.log("transferOnResp succcess", response);
            this.router.navigate(["/tabs/tab1"]);
            this.helper.presentToastSuccess(
              "Appointment sheduled for selected date and time "
            );
            this.dismissLoading();
          }
          this.dismissLoading();
        },
        (error) => {
          this.dismissLoading();
          this.router.navigate(["/tabs/tab1"]);
          // this.helper.presentToastSuccess("Appointment sheduled for selected date and time ");
          this.helper.presentToastError("Something went wrong");
        }
      );
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: "image/jpeg" });
    return blob;
  }

  createBlob(dataURI) {
    var byteString = atob(dataURI.split(",")[1]);
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);

    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }
}
